import type { ProductMenuDef } from '../type.js';

/**
 * スマートFAQ (ナレッジハブの公開ドキュメントを FAQ サイトとして配信) のメニュー定義。
 * 出典: apps/smart-faq/docs/product-brief.md (MVP のスコープはサイト編集とアンケート回答のみ)
 */
export const QANT_SMART_FAQ_MENU = {
  product: {
    name: 'smartFaq',
    icon: 'qantFaq',
    label: { ja: 'スマートFAQ', en: 'Smart FAQ' },
    description: { ja: 'FAQサイト構築・配信', en: 'Smart FAQ' },
  },
  menuGroups: {
    BASIC: {
      name: 'basic',
      menus: {
        SITE: {
          name: 'site',
          icon: 'issuesSupportSite',
          label: { ja: 'サイト編集', en: 'Site' },
          path: { host: 'qant', path: '/smart-faq/site' },
        },
        SURVEY_RESPONSES: {
          name: 'surveyResponses',
          icon: 'vocReview',
          label: { ja: 'アンケート回答', en: 'Survey Responses' },
          path: { host: 'qant', path: '/smart-faq/survey-responses' },
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
